import { type ActionEvent, Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["clearButton", "input"]
  declare readonly clearButtonTarget: HTMLElement
  declare readonly inputTarget: HTMLInputElement

  blurInput({ target }: ActionEvent): void {
    ;(target as HTMLElement).blur()
  }

  clear(): void {
    this.inputTarget.value = ""
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.inputTarget.focus()
  }

  hideButtonIfNeeded(e: FocusEvent): void {
    // Only hide button if controller element does not contain currently focused element.
    this.toggleClearButton(
      this.element.contains((e.relatedTarget as Node) || document.activeElement)
    )
  }

  showButton(): void {
    this.toggleClearButton(true)
  }

  private toggleClearButton(show: boolean): void {
    // Clear button can either be visually hidden (via aria/class) or absolutely hidden (via
    // `hidden`). The former is used when button visibility should NOT alter layout, and the
    // latter when it should.
    if (this.clearButtonTarget.hasAttribute("aria-hidden")) {
      this.clearButtonTarget.setAttribute("aria-hidden", show ? "false" : "true")
      this.clearButtonTarget.classList.toggle("invisible", !show)
    } else {
      this.clearButtonTarget.hidden = !show
    }
  }
}
